module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__select-remote--section"
  }, [_c('div', {
    staticClass: "system-builder__main-remotes--wrapper"
  }, _vm._l((_vm.sharedState.filteredRemotes), function(remote, index) {
    return _c('remoteItem', {
      attrs: {
        "remoteKey": index,
        "id": remote.ID
      }
    }, [(remote.images) ? _c('div', {
      slot: "remote-image"
    }, [_c('img', {
      attrs: {
        "src": remote.images.image.url,
        "alt": remote.images.image.alt
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      slot: "remote-description"
    }, [_c('h3', [_vm._v(_vm._s(remote.post_title))]), _vm._v(" "), _c('ul', {
      staticClass: "product-available-features"
    }, _vm._l((remote.remote_features), function(feature, featureIndex) {
      return (featureIndex < _vm.numberFeaturesToShow) ? _c('li', {
        domProps: {
          "innerHTML": _vm._s(feature)
        }
      }) : _vm._e()
    }))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13979014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/SelectRemote.vue
// module id = 416
// module chunks = 1